import React from 'react';
import createReactClass from 'create-react-class';

import Loader from '../../../common/components/notifications/Loader';
import MetadataFilter from '../MetadataFilter';
import Encoders from './Encoders';
import EncoderCreate from './EncoderCreate';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';

var EncoderListing = createReactClass({
    getInitialState: function () {
        return {
            term: '',
            isTyping: false,
            createModal: false,
            flashSupported: false
        };
    },

    termChanged: function (term) {
        this.setState({
            term: term,
            isTyping: false
        });
    },

    handleTypingStarted: function () {
        this.setState({
            isTyping: true
        });
    },

    toggleCreateModal: function (ev) {
        ev && ev.preventDefault();
        this.setState({
            createModal: !this.state.createModal
        });
    },

    save: function (encoder) {

        if (this.valid(encoder)) {
            this.toggleCreateModal();
            this.props.actions.add(encoder);
        }
    },

    valid: function (encoder) {
        var failed = [], messages = [];

        if (encoder.simpleName === '') {
            failed.push('simpleName');
            messages.push('Encoder Name is Required');
        }

        if (encoder.streamName === '') {
            failed.push('streamName');
            messages.push('Stream Name is Required');
        }

        if (failed.length) {
            this.setState({
                validators: failed
            });

            return false;
        }

        return true;
    },

    render: function () {
        if (this.props.isResolving) return <Loader message='Fetching Encoders' />;
        switch (this.props.mode) {
            case 'manage': return this.renderManager();
            case 'select': break;
        }
    },

    renderManager: function () {
        var listing = this.state.isTyping ?
            <Loader message='Filtering' /> :
            (<Encoders {...this.props}
                encoders={this.props.data}
                term={this.state.term.toLowerCase()}
            />)
        ;

        return (
            <div className="encoder-listing">

                <div className="callout clearfix">
                    <div className="col-md-8">
                        <MetadataFilter termChanged={this.termChanged} isTyping={this.handleTypingStarted}/>
                    </div>
                    <div className="col-md-4 text-right">
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_ENCODERS.CREATE}>
                            <button className="btn btn-primary" onClick={this.toggleCreateModal}>
                                <i className="fa fa-plus"/> Create Encoder
                            </button>
                        </RestrictedComponent>
                    </div>
                </div>

                <div className="well">
                    {listing}
                </div>

                {this.renderModals()}
            </div>
        );
    },

    renderModals: function () {
        if (this.state.createModal) {
            return <EncoderCreate
                save={this.save}
                createModal={this.state.createModal}
                toggleCreateModal={this.toggleCreateModal}/>;
        }
    }
});

export default EncoderListing;
